import { render, staticRenderFns } from "./fieldtype_yn.vue?vue&type=template&id=26a5fa1f&scoped=true&"
import script from "./fieldtype_yn.vue?vue&type=script&lang=js&"
export * from "./fieldtype_yn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a5fa1f",
  null
  
)

export default component.exports